import { api } from './api';

export interface PromoCode {
  id: number;
  code: string;
  description?: string | null;
  discountType: 'percentage' | 'flat';
  discountValue: number;
  maxDiscount?: number | null;
  minFare?: number | null;
  maxRedemptions?: number | null;
  perUserLimit: number;
  redemptionCount: number;
  targetRole?: string | null;
  targetCity?: string | null;
  validFrom?: string | null;
  validUntil?: string | null;
  isActive: boolean;
}

export type PromoInput = Partial<Omit<PromoCode, 'id' | 'redemptionCount'>> & {
  code: string;
  discountType: 'percentage' | 'flat';
  discountValue: number;
};

export const getPromos = (params?: { search?: string; activeOnly?: boolean }) =>
  api.get('/admin/promos', { params }).then((r) => r.data);

export const getPromoUsage = (id: number) =>
  api.get(`/admin/promo/${id}/usage`).then((r) => r.data);

export const createPromo = (data: PromoInput) =>
  api.post('/admin/promos', data).then((r) => r.data);

export const updatePromo = (id: number, data: Partial<PromoInput>) =>
  api.patch(`/admin/promo/${id}`, data).then((r) => r.data);

export const deletePromo = (id: number) =>
  api.delete(`/admin/promo/${id}`).then((r) => r.data);
